var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 24 24",
    fill: "none",
    id: "svg3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#daa520",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1
    },
    id: "g4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.41763,18.5409 C 10.1913,17.3978 11.2839,16 12,16 c 0.7161,0 1.8087,1.3978 2.5824,2.5409 C 15.0129,19.1769 14.5438,20 13.7757,20 H 10.2243 C 9.45619,20 8.9871,19.1769 9.41763,18.5409 Z",
    fill: "#0f0f0f",
    id: "path1-5",
    style: {
      fill: "#daa520",
      fillOpacity: 0.466667,
      stroke: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,9 C 12.3511,9 12.9855,8.23437 13.5273,7.47668 13.9798,6.84397 13.5091,6 12.7313,6 H 11.2687 C 10.4909,6 10.0202,6.84397 10.4727,7.47668 11.0145,8.23437 11.6489,9 12,9 Z",
    fill: "#0f0f0f",
    id: "path2-4",
    style: {
      fill: "#daa520",
      fillOpacity: 0.466667,
      stroke: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 4,2 C 4,1.44772 4.44772,1 5,1 h 14 c 0.5523,0 1,0.44772 1,1 0,0.55228 -0.4477,1 -1,1 H 17.9726 C 17.8373,5.41131 17.21,7.23887 16.2903,8.7409 15.4882,10.0511 14.4804,11.0808 13.4874,12 c 0.993,0.9192 2.0008,1.9489 2.8029,3.2591 0.9197,1.502 1.547,3.3296 1.6823,5.7409 H 19 c 0.5523,0 1,0.4477 1,1 0,0.5523 -0.4477,1 -1,1 H 5 C 4.44772,23 4,22.5523 4,22 4,21.4477 4.44772,21 5,21 H 6.02739 C 6.16267,18.5887 6.79004,16.7611 7.70965,15.2591 8.51183,13.9489 9.51962,12.9192 10.5126,12 9.51962,11.0808 8.51183,10.0511 7.70965,8.7409 6.79004,7.23887 6.16267,5.41131 6.02739,3 H 5 C 4.44772,3 4,2.55228 4,2 Z M 15.9691,21 C 15.8384,18.9511 15.3049,17.4797 14.5846,16.3034 13.8874,15.1645 12.9954,14.2641 12,13.3497 11.0046,14.2641 10.1126,15.1645 9.41535,16.3034 8.69515,17.4797 8.1616,18.9511 8.03092,21 Z M 8.03092,3 H 15.9691 C 15.8384,5.04891 15.3049,6.52026 14.5846,7.6966 13.8874,8.83549 12.9954,9.73587 12,10.6503 11.0046,9.73587 10.1126,8.83549 9.41535,7.6966 8.69515,6.52026 8.1616,5.04891 8.03092,3 Z",
    fill: "#0f0f0f",
    id: "path3",
    style: {
      fill: "#daa520",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.647edd66d335f22aa0b324495b2dd53b.svg";
export { ForwardRef as ReactComponent };